import { gql } from '@apollo/client'

type SendTowingDocumentBy = 'email' | 'sms'

export interface SendTowingDocumentLinkMutationVariables {
  input: {
    towingRecordId: number
    sendBy: SendTowingDocumentBy
    email?: string
    phone?: string
  }
}

export interface SendTowingDocumentLinkSuccess {
  __typename: 'SendTowingDocumentLinkSuccess'
  success: boolean
  message?: string | null
}

export interface UnauthorizedError {
  __typename: 'UnauthorizedError'
  error: {
    code: string
    message: string
  }
}

export type SendTowingDocumentLinkMutation = {
  sendTowingDocumentLink:
    | SendTowingDocumentLinkSuccess
    | UnauthorizedError
}

export const SEND_TOWING_DOCUMENT_LINK = gql`
  mutation SendTowingDocumentLink($input: SendTowingDocumentLinkInput!) {
    sendTowingDocumentLink(input: $input) {
      __typename
      ... on SendTowingDocumentLinkSuccess {
        success
        message
      }
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
     
    }
  }
`
